module.exports = __webpack_public_path__ + "static/media/bridge.eac65aff.svg";